import Loading from '@/common/components/Loading';
import { useContext, useLayoutEffect, useState, useEffect } from 'react';
import { useMutation } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import ArrLeft from '@/common/images/arr-left.svg';
import WriteOpinion, {
	OPINION_OPTIONS,
} from '../profile/components/WriteOpinion';
import { BoxOpinion } from '../word-lesson-type/WordLessonTypeList';
import ArrRightViolet from '../word-lesson-type/images/arr-right-violet.svg';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { CustomerDataContext } from '@/common/components/layout/productLayout/context/CustomerDataContext';
import { findScencesByVersionForCustomer } from '@/api/query/scene';
import IntroductionScreen from './components/IntroductionScreen/IntroductionScreen';
import {
	Title,
	Wrapper,
	BoxWrapper,
	SubTitle,
	IntroductionWrapper,
	RelativeAnchor,
} from './scenes.styles';
import ScenesListTutorialPopup from './components/ScenesListTutorialPopup/ScenesListTutorialPopup';
import { Scene } from './types/Scene';
import Category from './components/Category/Category';

const ScenesV3 = () => {
	const navigate = useNavigate();
	const { title, subtitle, suggest } = useLanguageData('features.scene');
	const [categories, setCategories] = useState<Scene[]>([]);
	const [selectedScene, setSelectedScene] = useState<Scene>();
	const [showOption, setShowOpinion] = useState(false);
	const [isTutorialVisible, setIsTutorialVisible] = useState(false);

	const findCtegoriesMutation = useMutation({
		mutationFn: (payload: any) => findScencesByVersionForCustomer(payload),
		onSuccess: ({ data }) => {
			setCategories(data);
		},
	});

	const { manageFavoriteMutation, favoriteArr } =
		useContext(CustomerDataContext);

	const handleAddToFavorite = (id, type) => {
		const payload = {
			_id: id,
			type,
			shouldAdd: favoriteArr?.includes(id) ? false : true,
		};

		manageFavoriteMutation.mutate(payload);
	};

	useEffect(() => {
		const isTutorialShowedBefore = !!localStorage.getItem(
			'scenes-v3-list-tutorial',
		);
		setIsTutorialVisible(!isTutorialShowedBefore);
	}, []);

	const handleCloseTutorial = () => {
		localStorage.setItem('scenes-v3-list-tutorial', 'true');
		setIsTutorialVisible(false);
	};

	useLayoutEffect(() => {
		const payload = {
			version: 'V3',
		};

		findCtegoriesMutation.mutate(payload);
		window.document.title = `Synthi Ai - ${title}`;
	}, []);

	return (
		<>
			{showOption && (
				<WriteOpinion setShow={setShowOpinion} from={OPINION_OPTIONS.SCENE} />
			)}

			{(manageFavoriteMutation.isLoading ||
				findCtegoriesMutation.isLoading) && <Loading />}
			<Wrapper>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						width: '100%',
					}}
				>
					<Link to={'/learn'}>
						<img
							src={ArrLeft}
							style={{
								width: '12px',
							}}
						/>
					</Link>
					<Title>{title}</Title>
					<div></div>
				</div>
				<SubTitle>{subtitle}</SubTitle>
				<BoxWrapper>
					{categories.map((d) => (
						<Category
							key={d._id}
							isFavorite={favoriteArr.includes(d._id)}
							onAddToFavorite={() => handleAddToFavorite(d._id, 'scenes_v3')}
							data={d}
							onClick={() => {
								navigate(`/learn/scenes-v3/${d._id}/introduction`);
							}}
						/>
					))}
					<BoxOpinion onClick={() => setShowOpinion(true)}>
						<div>{suggest}</div>
						<div>
							<img src={ArrRightViolet} />
						</div>
					</BoxOpinion>
				</BoxWrapper>
			</Wrapper>

			{isTutorialVisible && (
				<ScenesListTutorialPopup onClose={handleCloseTutorial} />
			)}
		</>
	);
};

export default ScenesV3;
